import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useCatalogItems, CatalogItem } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../contexts/ThemeContext';

const List: React.FC = () => {
  const { colors } = useTheme();
  return (
    <GenericListPage<CatalogItem>
      useData={useCatalogItems}
      config={{
        ...moduleConfig,
        getColumns: (formatDate, formatCurrency) => getColumns(formatDate, formatCurrency, colors),
        getToolbarIcon,
        getTableActions: (item, onDelete, _c, ctx, opts) => getTableActions(item, onDelete, colors, ctx, opts),
      }}
    />
  );
};

export default List;
